import { Autocomplete, TextField } from '@mui/material';
import { Control, Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AllEnums, EnumListKey } from '~/data/enums';
import { Form } from '~/features/RehireDialog/hooks/useRehireEmpForm';
import { useRehireEnumFilteredOptions } from '~/features/RehireDialog/hooks/useRehireEnumFilteredOptions';
import { useSxStyles } from '~/features/RehireDialog/useStyles';

type Props = {
  control: Control<Form>;
  allEnums: AllEnums;
};

export const InternalPositionComponent = ({ control, allEnums }: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const requiredText = t('fieldIsRequired');
  const fEmpLegalEntityValue = useWatch({
    control,
    name: 'rehire.empPosition.fEmpLegalEntity',
  });

  const filteredOptions = useRehireEnumFilteredOptions(
    control,
    allEnums,
    EnumListKey.EMPLOYEE_POSITION,
  );

  return (
    <Controller
      control={control}
      name={'rehire.empPosition.fInternalPositionPosition'}
      rules={{ required: requiredText }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          sx={{ ...sxStyles.selectStyle, ...sxStyles.inputBottomMargin }}
          placeholder={t('laSelectFirstLegEnt')}
          disabled={!fEmpLegalEntityValue}
          options={filteredOptions}
          getOptionLabel={(c) => c?.name || ''}
          onChange={(e, value) => {
            onChange(value?.code || '');
          }}
          value={filteredOptions.find((ep) => ep?.code === value) || null}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('laPosition')}
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      )}
    />
  );
};
